import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/CustomerSearch';
import './CustomerSearch.css';
import { connect } from 'react-redux';
import { ControlLabel, FormGroup, Form, Button, InputGroup, ToggleButtonGroup, ButtonToolbar, ToggleButton } from 'react-bootstrap';
import { AsyncTypeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { clearOrderDataFromLocalStorage } from '../common/ResetOrderPlannerData';
import { authContext } from '../../adalConfig';

import fetchClient from '../../components/common/FetchClient';
import { isNullOrUndefined } from 'util';

class CustomerSearch extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);

        this.state = {
            allowNew: false,
            isLoading: false,
            multiple: false,
            address: '',
            customer: '',
            options: [],
            auth: authContext.getCachedUser(),
            customerSearchMode: localStorage.getItem('customerSearchMode') || "My"
        };
    }

    componentWillMount() {
        // This method runs when the component is first added to the page

        if (localStorage.getItem('customer')) {
            this.setState((state, props) => {
                return { customer: localStorage.getItem('customer') };
            });
        }

        if (localStorage.getItem('address')) {
            this.setState((state, props) => {
                return { address: localStorage.getItem('address') };
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    clearCustomer() {
        localStorage.removeItem('customer');
        localStorage.removeItem('address');
        localStorage.removeItem('customerName');
        localStorage.removeItem('addressName');
        localStorage.removeItem('street');
        localStorage.removeItem('city');
        localStorage.removeItem('state');
        localStorage.removeItem('zip');
        localStorage.removeItem('repName');
        localStorage.removeItem('repAccount');

        window.location.reload();
    }

    _handleSearch = (query) => {
        if (authContext.getCachedUser() === null) {
            window.open('/', '_self');
            return;
        }

        console.log(query);
        var url = `api/Customers/GetCustomers`;

        this.setState({ isLoading: true });

        var that = this;

        fetchClient(url, {
            params: {
                azureToken: '',
                keywords: query,
                username: that.state.auth.userName
            }
        }).then(function (resp) {
            console.log(resp);
            if (resp) {
                var options = [];
                   
                resp.data.map(function (i) {
                    
                    var repAccount = "";
                    let repName = "Unassigned";
                    let repId = "";

                    try {
                        repAccount = i.toString();
                        repAccount = repAccount.split('~~~')[11];
                        repName = repAccount.split(':')[1];
                        repId = repAccount.split(':')[2];
                        repAccount = repAccount.split(':')[0];
                    }
                    catch(err) {
                        console.log('exception hit', err);
                    }

                    if (repAccount === "OtherRepAccount" && that.state.customerSearchMode === "All") {
                        if (i.split('~~~')[1] !== undefined) {
                            options.push({
                                serverValue: i,
                                addressId: i.split('~~~')[0],
                                addressName: i.split('~~~')[3],
                                customerId: i.split('~~~')[1],
                                customerName: i.split('~~~')[2],
                                street: i.split('~~~')[4],
                                city: i.split('~~~')[5],
                                state: i.split('~~~')[6],
                                zip: i.split('~~~')[7],
                                repName: repName,
                                repAccount: repId
                            })
                        }
                    }
                    
                    else if (repAccount === "Unassigned" && (that.state.customerSearchMode === "All" || that.state.customerSearchMode === "Unassigned")) {
                        if (i.split('~~~')[1] !== undefined) {
                            options.push({
                                serverValue: i,
                                addressId: i.split('~~~')[0],
                                addressName: i.split('~~~')[3],
                                customerId: i.split('~~~')[1],
                                customerName: i.split('~~~')[2],
                                street: i.split('~~~')[4],
                                city: i.split('~~~')[5],
                                state: i.split('~~~')[6],
                                zip: i.split('~~~')[7],
                                repName: "Unassigned",
                                repId: ""
                            })
                        }
                    }

                    else if (repAccount === "MyAccount" || that.state.customerSearchMode === "All") {
                        if (i.split('~~~')[1] !== undefined) {
                            options.push({
                                serverValue: i,
                                addressId: i.split('~~~')[0],
                                addressName: i.split('~~~')[3],
                                customerId: i.split('~~~')[1],
                                customerName: i.split('~~~')[2],
                                street: i.split('~~~')[4],
                                city: i.split('~~~')[5],
                                state: i.split('~~~')[6],
                                zip: i.split('~~~')[7],
                                repName: repName,
                                repAccount: repId
                            })
                        }
                    }
                });

                that.setState({
                    isLoading: false,
                    options,
                });

            }
        });
    }

    handleChange(e) {
        this.setState({ customerSearchMode: e });
        localStorage.setItem('customerSearchMode', e);
    }

    _handleSearch(result) {
        localStorage.setItem('customer', result.customer);
        localStorage.setItem('address', 456);
    }

    render() {
        return (
            <Form>
                <h1>Customer Search</h1>

                <p>List mode:</p>
                <ButtonToolbar>
                    <ToggleButtonGroup type="radio" name="options"
                        onChange={this.handleChange}
                        value={this.state.customerSearchMode}>
                            <ToggleButton value={"My"}>My</ToggleButton>
                            <ToggleButton value={"Unassigned"}>Unassigned</ToggleButton>
                            <ToggleButton value={"All"}>All</ToggleButton>
                    </ToggleButtonGroup>
                </ButtonToolbar>
                <br />
                <FormGroup
                    controlId="customerSearchForm">
                    <ControlLabel>Find a customer:</ControlLabel>
                    <InputGroup>
                        <InputGroup.Button>
                            <Button onClick={this.clearCustomer}>
                                Clear
                            </Button>
                        </InputGroup.Button>
                        <AsyncTypeahead
                            {...this.state}
                            labelKey={option => `[${option.customerId}] ${option.customerName} - ${option.addressName} - ${option.street} ${option.city}, ${option.state} ${option.zip}`}
                            minLength={3}
                            onSearch={this._handleSearch}
                            options={this.state.options}
                            useCache={false}
                            autoComplete={false}
                            autoCorrect={false}
                            autoCapitalize={false}
                            spellCheck={false}
                            placeholder={this.state.customer || 'Search for customer'}
                            renderMenu={(results, menuProps) => (
                                <Menu {...menuProps}>
                                    {results.map((result, index) => (
                                        
                                        <MenuItem option={result} position={index} key={index} onClick={() => {
                                            clearOrderDataFromLocalStorage();
                                            localStorage.removeItem('repName');
                                            localStorage.removeItem('repAccount');

                                            AsyncTypeahead.disabled = true;

                                            var customerId = result.customerId;
                                            var addressId = result.addressId;
                                            var customerName = result.customerName;
                                            var addressName = result.addressName;

                                            localStorage.setItem('customer', customerId);
                                            localStorage.setItem('address', addressId);
                                            localStorage.setItem('customerName', customerName);
                                            localStorage.setItem('addressName', addressName);
                                            localStorage.setItem('street', result.street);
                                            localStorage.setItem('city', result.city);
                                            localStorage.setItem('state', result.state);
                                            localStorage.setItem('zip', result.zip);

                                            if (result.repName) {
                                                localStorage.setItem('repName', result.repName);
                                            }
                                            if (result.repAccount) {
                                                localStorage.setItem('repAccount', result.repAccount);
                                            }

                                            this.setState((state, props) => {
                                                return { address: localStorage.getItem('address') };
                                            });

                                            this.setState((state, props) => {
                                                return { addressName: localStorage.getItem('addressName') };
                                            });

                                            this.setState((state, props) => {
                                                return { customer: localStorage.getItem('customer') };
                                            });

                                            this.setState((state, props) => {
                                                return { customer: localStorage.getItem('customerName') };
                                            });

                                            this.setState((state, props) => {
                                                return { street: localStorage.getItem('street') };
                                            });

                                            this.setState((state, props) => {
                                                return { city: localStorage.getItem('city') };
                                            });

                                            this.setState((state, props) => {
                                                return { state: localStorage.getItem('state') };
                                            });

                                            this.setState((state, props) => {
                                                return { zip: localStorage.getItem('zip') };
                                            });

                                            if (result.repName) {
                                                this.setState((state, props) => {
                                                    return { repName: localStorage.getItem('repName') };
                                                });

                                                this.setState((state, props) => {
                                                    return { repAccount: localStorage.getItem('repAccount') };
                                                });
                                            }

                                            window.location.reload();
                                        }}>
                                            {result.customerId !== undefined &&
                                                <div>
                                                    [{result.customerId}] {result.customerName}
                                                    <br />[{result.addressId}] {result.addressName}
                                                    <br />{result.street}
                                                    <br />{result.city}, {result.state} {result.zip}
                                                </div>
                                            }
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                        />
                    </InputGroup>

                    <br /><br />
                    <p><b>Selected Customer:</b><br/>
                    {(() => {
                        if (localStorage.getItem('customer')) {
                            return '[' + localStorage.getItem('customer') + '] '
                                + localStorage.getItem('customerName');
                        }
                        else {
                            return 'Select a customer above.';
                        }
                    })()}
                    <br />
                    {(() => {
                        if (localStorage.getItem('customer')) {
                            return '[' + localStorage.getItem('address') + '] '
                                + localStorage.getItem('addressName');
                        }
                    })()}
                    <br />
                    {(() => {
                        if (localStorage.getItem('customer')) {
                            return localStorage.getItem('street');
                        }
                    })()}
                    <br />
                    {(() => {
                        if (localStorage.getItem('customer')) {
                            return localStorage.getItem('city') + ', '
                                + localStorage.getItem('state') + ', '
                                + localStorage.getItem('zip');
                        }
                    })()}
                    <br /><br /><b>
                    {(() => {
                        if (localStorage.getItem('repName')) {
                            return "Sales Rep:";
                        }
                    })()}</b>
                    <br />
                    {(() => {
                        if (localStorage.getItem('repName')) {
                            if (localStorage.getItem('repName') === "Unassigned") {
                                return localStorage.getItem('repName');
                            } else {
                                return '[' + localStorage.getItem("repAccount") + ']' + ' ' + localStorage.getItem('repName');
                            }
                        }
                    })()}

                    </p>
                </FormGroup>
            </Form>
        );
    }
}

export default connect(
    state => state.customerSearch || {},
    dispatch => bindActionCreators(actionCreators, dispatch)
)(CustomerSearch);



// WEBPACK FOOTER //
// ./src/components/sales/CustomerSearch.js